import { useContext } from 'react'

import { OptimizerConfigDefaultContext } from '@provider/Optimizer/ConfigDefaultProvider'

import { IConfigDefaultParamsOptimizerProvider } from '@base/@types/providers/Optimizer/ConfigDefaultParamsOptimizer'
export default function useOptimizerDefault(): IConfigDefaultParamsOptimizerProvider {
  const context = useContext(OptimizerConfigDefaultContext)

  return context
}
